import { render, staticRenderFns } from "./ImgConfig.vue?vue&type=template&id=0e23107e&scoped=true&"
import script from "./ImgConfig.vue?vue&type=script&lang=js&"
export * from "./ImgConfig.vue?vue&type=script&lang=js&"
import style0 from "./ImgConfig.vue?vue&type=style&index=0&id=0e23107e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e23107e",
  null
  
)

export default component.exports